import { useNavigate } from 'react-router-dom'

import { Button, type MediumIcon } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import {
  BaseRequestItem,
  RequestComponentProps,
} from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

const EndedHiringInUnterminatedEmployee = ({ request, index, compact }: RequestComponentProps) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const id = String(request.resourceIdentifier)

  return (
    <>
      <BaseRequestItem
        icon={request.icon as MediumIcon}
        request={request}
        url={String(request.actionUrl)}
        index={index}
        compact={compact}
        buttons={
          <Button
            onClick={() => navigate(navigation.employees.id.terminate.fullPath({ id }))}
            type="secondary"
          >
            {i18n.t('dashboard.tasks.endedHiringInUnterminatedEmployee.button')}
          </Button>
        }
      />
    </>
  )
}

export default EndedHiringInUnterminatedEmployee
